export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6718.190961a0.jpg";